<template>
  <div class="footer">
    <span>
      Copyright &copy;
      <a
        v-if="isshow_icp"
        class="icp-link"
        href="http://beian.miit.gov.cn"
        target="_blank"
      >{{isshow_icp}}</a>
      <img v-if="title==='齐进企管在线商学院'"  src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" style="height: 12px;width: 12px;">
      <a v-if="title==='齐进企管在线商学院'" href="https://beian.mps.gov.cn/#/query/websearch?code=33020502001095" class="icp-link" rel="noreferrer" target="_blank">浙公网安备33020502001095号</a>
      {{title}} All Rights Reserved.
    </span>
    <a :href="online_qiye_card.href" target="_blank" v-if="online_qiye_card">
      <img :src="online_qiye_card.icon" class="onlineCard" />
    </a>

    <span></span>
  </div>
</template>

<script>
import getWebsiteAjax from '@/util/getWebsiteAjax'
export default {
  name: 'Footer',
  data() {
    return {
      // title:'',
      // isshow_icp: null,
      // online_qiye_card:{}
    }
  },
  created() {
    // const data = await getWebsiteAjax()
    // this.$axios.post('/api/studysys/common/getWebsiteAjax').then(({ data }) => {
    //   this.$store.commit('setValue', data.data)
    //   // this.title = data.data.title
    //   // this.isshow_icp = data.data.isshow_icp
    //   this.online_qiye_card = data.data.online_qiye_card || ''
    // })
    // this.title = data.title
    // this.isshow_icp = data.isshow_icp
    // this.online_qiye_card = data.online_qiye_card || ''
  },
  computed: {
    title() {
      return this.$store.state.title
    },
    isshow_icp() {
      return this.$store.state.isshow_icp?this.$store.state.isshow_icp.replace(/,/g,"   "): ''
    },
    online_qiye_card() {
      return this.$store.state.online_qiye_card || ''
    }
  },
  mounted() {
    // console.log(this.online_qiye_card, 'online_qiye_card')
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: rgba($color: #fff, $alpha: 0.4);
  background-color: #1e2022;
  font-size: 12px;
  z-index: 1000;
  span {
    margin: 0 9px;
  }
}
.icp-link {
  color: rgba($color: #fff, $alpha: 0.4);
}
.onlineCard {
  width: 24px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue